<template>
  <component :is="dynamicComponent" />
</template>

<script>
import { defineComponent, h, resolveComponent } from 'vue';
import { compile } from '@vue/compiler-dom';
import InfoTooltip from './InfoTooltip.vue';
import ErrorTooltip from './ErrorTooltip.vue';

import {
  openBlock,
  createElementBlock,
  createVNode,
  createElementVNode,
  createTextVNode,
  createCommentVNode,
  Fragment,
  toDisplayString
} from 'vue';

export default {
  name: 'DynamicRenderer',
  props: {
    templateString: {
      type: String,
      required: true
    }
  },
  computed: {
    dynamicComponent() {
      const { code } = compile(this.templateString, { mode: 'function' });

      const render = new Function(
        'Vue',
        `${code}; return render`
      )(VueShim());

      return defineComponent({
        name: 'DynamicCompiledComponent',
        components: { InfoTooltip, ErrorTooltip },
        render
      });
    }
  }
};

function VueShim() {
  return {
    h,
    resolveComponent,
    openBlock,
    createElementBlock,
    createVNode,
    createElementVNode,
    createTextVNode,
    createCommentVNode,
    Fragment,
    toDisplayString
  };
}
</script>
